import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { StoreChangesService } from '../services/store-changes.service';
import { IUser } from '../models/interfaces/user.model';
import { MessageService } from 'primeng/api';
import { BrowserService } from '../services/browser.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ToUsersittingGuard {
  user!: IUser;
  flag = false
  constructor(private storeChangesServ: StoreChangesService, private router: Router, private authServ: AuthService,
    private messageService: MessageService, private activatedRoute: ActivatedRoute, private browserService: BrowserService) {

  }
  ngOnInit(): void {

  }
  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   const sessionStorageBr = this.browserService.getSessionStorage();
  //   if (sessionStorageBr) {

  //   }
  //   let valid = sessionStorage.getItem('userExist')
  //   let status: boolean = false;
  //   if (valid == 'true') {
  //     status = true
  //   } else {

  //     this.router.navigate([`en/auth/signin/`, { route: state.url }]);
  //     setTimeout(() => {
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: 'you must login ',
  //       });
  //     }, 500);
  //     status = false
  //   }
  //   return status
  // }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authServ.validate().pipe(
      switchMap((response: IUser) => {
        if (response && response._id) {
          return of(true);
        } else {
          this.router.navigate([`/auth/signin/`, { route: state.url }]);
          setTimeout(() => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'you must login ',
            });
          }, 500);
          return of(false);
        }
      }),
      catchError(() => {
        this.router.navigate([`/auth/signin/`, { route: state.url }]);
        setTimeout(() => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'you must login ',
          });
        }, 500);
        return of(false);
      })
    );
    // let status: boolean = false;
    // console.log(this.authServ.getUserShop())
    // if (this.authServ.getUserShop() == null) {
    //   // this.router.navigateByUrl('/auth/signin');
    //   // this.messageService.add({
    //   //   severity: 'error',
    //   //   summary: 'Error',
    //   //   detail: 'you must login ',
    //   // });

    //   this.router.navigate([`/auth/signin/`, { route: state.url }]);
    //   setTimeout(() => {
    //     this.messageService.add({
    //       severity: 'error',
    //       summary: 'Error',
    //       detail: 'you must login ',
    //     });
    //   }, 500);
    //   status = false
    // } else {
    //   status = true;
    // }

    // return status
    // let status: boolean = false;
    // // console.log(this.authService.getUserShop())
    // if (this.authServ.getUserShop() == null) {
    //   this.authServ.validate().subscribe({
    //     next: (response) => {
    //       status = true
    //     }, error: (err) => {
    //       this.router.navigate([`/auth/signin/`, { route: state.url }]);
    //       setTimeout(() => {
    //         this.messageService.add({
    //           severity: 'error',
    //           summary: 'Error',
    //           detail: 'you must login ',
    //         });
    //       }, 500);
    //       status = false
    //     }
    //   })
    // } else {
    //   status = true;
    // }

    // return status
  }

}
